<template>
    <Layout>
      <PageHeader :title="title" :items="items"></PageHeader>
      <div class="row" id="series">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center mb-4">
                <div class="col-md-6">
                  <div class="form-inline navbar-search">
                    <div class="input-group">
                      <input v-on:keyup="search" name="title" class="form-control bg-light border-0 small"
                        placeholder="Search Title" aria-label="Search" aria-describedby="basic-addon2" value=""
                        v-model="filter" />
                      <div class="input-group-append">
                        <button class="btn btn-search" @click="searchFor">
                          <i class="fas fa-search fa-sm"> </i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3"></div>
                <div class="col-md-3">
                  <div class="d-flex align-items-center">
                    <span style="white-space: nowrap" class="mr-2">
                      Filter Transaction Type:
                    </span>

                    <b-form-select
                      v-model="selected_plans"
                      :options="filter_plan_options"
                      value-field="value"
                      text-field="label"
                      class="w-100"
                      size="sm"
                    />
                  </div>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <div v-if="!tableData?.transactions?.length" class="text-center text-muted mb-3">
                  <p style="font-size: 1.25rem;"><strong>No data found.</strong></p>
                </div>
                <b-table
                  striped
                  bordered
                  :items="tableData.transactions"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :per-page="0"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter-included-fields="filterOn"
                  responsive="sm"
                  class="table-bordered table-hover"
                  :key="key"
                >
                  <template v-slot:cell(credits)="row">
                    <span v-if="row.item.credits_added" style="color: green;">
                      +{{ row.item.credits_added }}
                    </span>

                    <span v-else-if="row.item.credits_deducted" style="color: red;">
                      -{{ row.item.credits_deducted }}
                    </span>

                    <span v-else>
                      0
                    </span>
                  </template>
                  <template v-slot:cell(transaction_type)="row">
                    <span v-if="row.item.credits_added" style="color: green;">
                      Credit
                    </span>

                    <span v-else-if="row.item.credits_deducted" style="color: red;">
                      Debit
                    </span>
                  </template>
                  <template v-can="'ai-tools-members-services'" v-slot:cell(tokens)="row">
                    <div>
                      <!-- Editing mode -->
                      <div v-if="editedRowId === row.item.id">
                        <div class="input-group" style="max-width: 200px;">
                          <input
                            type="number"
                            v-model.number="addTokens"
                            placeholder="Add tokens"
                            class="form-control"
                          />
                          <input
                            type="number"
                            :value="existingTokens + addTokens"
                            readonly
                            class="form-control"
                          />
                          <button class="btn btn-success" @click="saveTokens(row.item.id)">Save</button>
                        </div>
                      </div>

                      <!-- View mode -->
                      <div v-else @click="enableTokenEdit(row.item)" style="cursor: pointer;">
                        <p>{{ row.item.tokens }}</p>
                      </div>
                    </div>
                  </template>
                  <template v-can="'ai-tools-members-services'" v-slot:cell(show_details)="row">
                      <b-button @click="fetchTooldetails(row.item)" variant="outline-primary" class="btn-sm m-1">Show Details</b-button>
                  </template>
                  <template v-slot:cell(type)="row">
                      <p v-if="row.item.type == 'credit'" style="color: green;">{{ capitalize(row.item.type) }}</p>
                      <p v-else style="color: red;">{{ capitalize(row.item.type) }}</p>
                  </template>

                </b-table>
              </div>
              <template v-if="tableData.total > tableData.size">
                <div class="data_paginate">
                  <div class="dataTables_paginate paging_simple_numbers d-flex justify-content-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- <b-pagination v-model="currentPage" first-number last-number :total-rows="tableData.total"
                        :total-pages="tableData.total_pages" :per-page="tableData.per_page"></b-pagination> -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="tableData.total"
                          :per-page="tableData.size || 10"
                          first-number
                          last-number
                          @input="onPageChange"
                        />
                    </ul>
                  </div>
                  <div class="form-inline navbar-search">
                    <span class="mr-2">Go to a Particular Paginated Page :</span>
                    <div class="input-group">
                      <b-form-input id="case" v-model="pageNo" placeholder="Enter Page No" class="in-width">
                      </b-form-input>
                      <div class="input-group-append">
                        <button class="btn btn-search" @click="filterPage">
                          <i class="fas fa-search fa-sm"> </i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </template>
  
  <script>
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import MixinRequest from "../../../mixins/request";
  import postsMixin from "../../../mixins/ModuleJs/wow-doctor-credit-history";
  
  export default {
    data() {
      return {
        title: "List Wow Doctor Credit History",
        showInput: false,
        items: [
          {
            text: "back",
            href: "/wow-doctors",
          },
          {
            text: "List",
          },
        ],
      };
    },
    mixins: [postsMixin, MixinRequest],
    components: {
      Layout,
      PageHeader
    },
  };
  </script>
  